import { useEffect, useState } from 'react';
import { useDebouncedValue } from '@/common/hooks/useDebouncedValue';

/** Helpers de validateSearch para listas: valores inválidos/padrão viram undefined (URL limpa). */
export const optStr = (v: unknown): string | undefined =>
  typeof v === 'string' && v.trim() ? v : undefined;

export const optPage = (v: unknown): number | undefined => {
  const n = typeof v === 'number' ? v : typeof v === 'string' ? Number(v) : NaN;
  return Number.isInteger(n) && n > 1 ? n : undefined;
};

export const optEnum = <T extends string>(v: unknown, allowed: readonly T[]): T | undefined =>
  allowed.includes(v as T) ? (v as T) : undefined;

/** Campo de busca: digita local, grava na URL (replace) após debounce. */
export function useUrlText(urlValue: string | undefined, commit: (v: string | undefined) => void) {
  const [input, setInput] = useState(urlValue ?? '');
  const debounced = useDebouncedValue(input, 300);
  useEffect(() => {
    const next = debounced.trim() || undefined;
    if (next !== (urlValue ?? undefined)) commit(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);
  return [input, setInput] as const;
}
